import type React from 'react';

export const RequestDetailsFooter: React.FC<{ extra?: React.ReactNode; okButton: React.ReactNode }> = ({ extra, okButton }) => (
  <>
    {extra}
    {okButton}
  </>
);
